import { render, staticRenderFns } from "./Agentist.vue?vue&type=template&id=64c10f6a&scoped=true"
import script from "./Agentist.vue?vue&type=script&lang=js"
export * from "./Agentist.vue?vue&type=script&lang=js"
import style0 from "./Agentist.vue?vue&type=style&index=0&id=64c10f6a&prod&scoped=true&lang=css"
import style1 from "./Agentist.vue?vue&type=style&index=1&id=64c10f6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c10f6a",
  null
  
)

export default component.exports